
import { useState } from "react";

export function useSidebarState() {
  const [searchTerm, setSearchTerm] = useState("");
  const [organizationFilter, setOrganizationFilter] = useState<string>("todas");
  const [createTypeDialogOpen, setCreateTypeDialogOpen] = useState(false);
  const [createComponentDialogOpen, setCreateComponentDialogOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState<{ [key: string]: boolean }>({});
  const [componentTypes, setComponentTypes] = useState<any[]>([]);
  const [loadingComponentTypes, setLoadingComponentTypes] = useState(false);

  const toggleGroup = (groupName: string) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupName]: !prev[groupName]
    }));
  };

  return {
    searchTerm,
    setSearchTerm,
    organizationFilter,
    setOrganizationFilter,
    createTypeDialogOpen,
    setCreateTypeDialogOpen,
    createComponentDialogOpen,
    setCreateComponentDialogOpen,
    isSaving,
    setIsSaving,
    expandedGroups,
    toggleGroup,
    componentTypes,
    setComponentTypes,
    loadingComponentTypes,
    setLoadingComponentTypes,
  };
}
